export default __webpack_public_path__ + "static/media/CheckBox.29ee0e20.svg";